/* wsapi3-blog-slider v1.0 */
/* Deploy Version 2026-10-05 14:43:39 */
/*
 * wsapi3-blog-slider — carrossel com os últimos artigos do blog da loja (foto, título, subtítulo
 * e, opcionalmente, a data).
 *
 * Âncora (qualquer página):
 *   <span data-wsjs-module="blog-slider" data-ws-render="server"
 *         data-wsjs-options="limit: 8; showDate: false;"
 *         data-wsjs-slide="slides.perView: 4; slides.spacing: 20;"></span>
 *
 *   limit    — quantos artigos entram no carrossel (1–20, padrão 8)
 *   Artigos sem imagem não entram (nem no servidor, nem aqui).
 *   showDate — true exibe a data de publicação no card (padrão oculta)
 *   imgArea  — área do imageResize/imageDimensions do head (padrão "blog")
 *   Sem data-wsjs-slide os cards viram uma grade simples, sem carrossel.
 *
 * O nome do módulo (blogSlider) é o mesmo data-wsjs-sectype do elemento "Blog" do editor
 * drag-and-drop — o editor chama wsMain.modules[sectype].get() ao soltar a seção.
 *
 * O servidor (BlogServerRenderService.renderSlider) entrega só a "primeira página" de cards pra
 * reservar a altura certa; aqui sempre se busca e reconstrói do zero (mesmo trade-off dos
 * fabricantes: createSlide() em cima de HTML pronto já calculou tamanho de slide absurdo).
 * Mesmo markup de card do servidor — manter os dois em sincronia.
 */
wsMain.createModule({
  name: "blogSlider",
  version: '1.0',
  updatedAt: '2026-10-02',
  function: "get",

  DEFAULT_LIMIT: 8,
  MAX_LIMIT: 20,

  _limit(elm) {
    const options = wsMain.tools.getWsData(elm, 'options') || {};
    const n = parseInt(options.limit, 10);
    if (!Number.isFinite(n) || n < 1) return wsMain.modules['blogSlider'].DEFAULT_LIMIT;
    return Math.min(n, wsMain.modules['blogSlider'].MAX_LIMIT);
  },

  async get() {
    const tags = document.querySelectorAll('[data-wsjs-module="blog-slider"]');
    if (!tags || tags.length == 0) return true;

    const self = wsMain.modules['blogSlider'];

    // Só artigos com imagem entram no carrossel. Busca sempre o teto (MAX_LIMIT), igual ao
    // servidor, pra ainda sobrar artigo suficiente pro limit depois de descartar os sem foto.
    let records = [];
    try {
      const resp = await ApiWS.Calls._get('/store/blog/list', { page: 1, page_size: self.MAX_LIMIT });
      records = resp && Array.isArray(resp.records)
        ? resp.records.filter(r => r && r.published !== false && String(r.image || '').trim())
        : [];
    } catch (err) {
      console.error('[blog-slider] falha ao buscar artigos:', err);
      return true;
    }

    tags.forEach(t => {
      try {
        self.create(records.slice(0, self._limit(t)), t);
      } catch (err) {
        console.error('[blog-slider] falha ao montar carrossel:', err);
      }
    });

    return true;
  },

  _esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  },

  // Foto com área do imageResize / imageDimensions do head (skill imagens-cloudflare): mesmos
  // src/srcset/sizes/width/height que o SSR gera pra <img data-ws-img="blog">.
  _photo(article, title, imgArea) {
    const esc = wsMain.modules['blogSlider']._esc;
    let src = article.image, srcset = '', sizes = '', w = 600, h = 338;
    try {
      const dims = wsMain.tools.imageDimensions.get(imgArea);
      if (dims) { w = dims.w; h = dims.h; }
    } catch (_) { }
    try {
      const resized = wsMain.tools.imageResize.attrs(src, imgArea);
      if (resized) { src = resized.src; srcset = resized.srcset; sizes = resized.sizes; }
    } catch (_) { }
    return `<img src="${esc(src)}"` +
      (srcset ? ` srcset="${esc(srcset)}" sizes="${esc(sizes)}"` : '') +
      ` alt="${esc(title)}" width="${w}" height="${h}" data-ws-img="${esc(imgArea)}" loading="lazy">`;
  },

  _card(article, showDate, imgArea) {
    const self = wsMain.modules['blogSlider'];
    const esc = self._esc;
    const href = article.url || ('/blog/' + (article.slug || ''));
    const title = article.title || '';
    const date = article.date_formatted || '';

    const photo = article.image
      ? `<div class="blog-slider-photo">${self._photo(article, title, imgArea)}</div>`
      : '<div class="blog-slider-photo blog-slider-no-photo"></div>';

    return `<a class="blog-slider-card" href="${esc(href)}" title="${esc(title)}">` +
      photo +
      '<div class="blog-slider-info">' +
      (showDate && date ? `<span class="blog-slider-date">${esc(date)}</span>` : '') +
      `<h3 class="blog-slider-title">${esc(title)}</h3>` +
      (article.subtitle ? `<p class="blog-slider-subtitle">${esc(article.subtitle)}</p>` : '') +
      '</div></a>';
  },

  create(records, elm) {
    // Sem artigos: a âncora fica como está — a seção (data-wsjs-container) continua oculta.
    if (!records || records.length == 0) return;

    const self = wsMain.modules['blogSlider'];
    const options = wsMain.tools.getWsData(elm, 'options') || {};
    const slideOptions = wsMain.tools.getWsData(elm, 'slide');
    const showDate = options.showDate === true || options.showDate === 'true';
    const imgArea = options.imgArea || 'blog';

    const holder = wsMain.tools.createElm({
      type: 'div',
      attrs: { class: 'blog-slider-holder' + (slideOptions ? '' : ' blog-slider-grid') },
    });
    holder.innerHTML = records.map(r => self._card(r, showDate, imgArea)).join('');

    // Anexa ANTES de montar o slide: createSlide() mede a largura do container (ver
    // wsapi3-manufacturers.js). visibility (não display) esconde a pintura crua sem tirar o
    // espaço do layout.
    wsMain.tools.replaceSpanTag(holder, elm);

    if (slideOptions) {
      holder.style.visibility = 'hidden';
      const [slideSuccess, slider] = wsMain.tools.createSlide(holder, slideOptions);
      if (slideSuccess && slider) {
        slider.update();
        // Setas no meio da foto: a altura dela depende da largura do slide (aspect-ratio).
        const placeArrows = () => {
          const photo = holder.querySelector('.blog-slider-photo');
          if (photo && photo.offsetHeight) holder.style.setProperty('--bs-arrow-top', (photo.offsetHeight / 2) + 'px');
        };
        placeArrows();
        slider.on('updated', placeArrows);
      }
      holder.style.visibility = '';
    }

    return true;
  },
});
